import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  exportConversationsWithFilters,
  type ConversationExportCells,
  type ConversationExportFilters,
  type ConversationExportOptions,
} from '@/lib/utils/conversations-export';

export interface ExportConversationsParams {
  filters: ConversationExportFilters;
  options: ConversationExportOptions;
  cells?: ConversationExportCells;
}

export function useExportConversations() {
  return useMutation({
    mutationFn: async ({ filters, options, cells }: ExportConversationsParams) => {
      const toastId = toast.loading('Exporting conversations...', {
        description: 'Fetching conversation data',
      });

      try {
        await exportConversationsWithFilters(filters, options, (current, total) => {
          toast.loading('Exporting conversations...', {
            id: toastId,
            description: `Processing ${current} of ${total} conversations`,
          });
        }, cells);

        toast.success('Conversations exported successfully', { id: toastId });
      } catch (error) {
        toast.error('Failed to export conversations', {
          id: toastId,
          description: 'Please try again',
        });
        throw error;
      }
    },
    onError: (error) => {
      console.error('Failed to export conversations:', error);
    },
  });
}
